<div class="shop-layout__sidebar">
    <div class="block block-sidebar" [ngClass]="{
        'block-sidebar--offcanvas--always': offcanvas === 'always',
        'block-sidebar--offcanvas--mobile': offcanvas === 'mobile',
        'block-sidebar--open': isOpen
    }">
        <div class="block-sidebar__backdrop" (click)="sidebar.close()"></div>
        <div class="block-sidebar__body">
            <div class="block-sidebar__header">
                <div class="filter-header">
                    {{"filters"|translate}}
                </div>
                <button class="block-sidebar__close" type="button" (click)="sidebar.close()">
                    <app-icon name="cross-20" size="20"></app-icon>
                </button>
            </div>
            <div class="block-sidebar__item">
                <form [formGroup]="form" class="widget widget-filters bg-card-new card-radius-06 border-0" [ngClass]="{
                    'widget-filters--offcanvas--always': offcanvas === 'always',
                    'widget-filters--offcanvas--mobile': offcanvas === 'mobile'
                }">
                    <div class="filter-header">
                        {{"filters"|translate}}
                    </div>
                    <ng-container formArrayName="properties">
                        <ng-container *ngFor="let row of searchInfoClone?.rows">
                            <ng-container *ngFor="let block of row?.blocks;let i=index">

                                <div class="col-span-12 md:col-span-{{block.width}}">
                                    <ng-container formGroupName="{{i}}">
                                        <ng-container *ngIf="block?.property?.type =='list'">
                                            <app-select-input *ngIf="!block.property?.filterType || block.property?.filterType == 'list'" (selectChange)="checkOptions()" [multiple]="block.property?.multipleSelect || false" [control]="propertyControl?.at(i)?.controls['value']"
                                                [label]="translateHelper.localize(block.property?.name)" [customLabel]="translateHelper.localize(block.property?.filterLabel)" [selectList]="block.property?.availableValues" appearance="filter" floatLabel="always"
                                                [placeholder]="('please_select'|translate) + ' ' + translateHelper.localize(block.property?.name)"></app-select-input>

                                            <app-select-search *ngIf="block.property?.filterType == 'search'" (selectChange)="checkOptions()" [multiple]="block.property?.multipleSelect || false" [control]="propertyControl?.at(i)?.controls['value']"
                                                [label]="translateHelper.localize(block.property?.name)" [customLabel]="translateHelper.localize(block.property?.filterLabel)" [selectList]="block.property?.availableValues" appearance="filter" floatLabel="always"
                                                [placeholder]="('please_select'|translate) + ' ' + translateHelper.localize(block.property?.name)"></app-select-search>


                                            <app-select-button *ngIf="block.property?.filterType == 'buttons'" (selectChange)="checkOptions()" [multiple]="block.property?.multipleSelect || false" [control]="propertyControl?.at(i)?.controls['value']"
                                                [label]="translateHelper.localize(block.property?.name)" [customLabel]="translateHelper.localize(block.property?.filterLabel)" [selectList]="block.property?.availableValues" [combineControl]="propertyControl?.at(i)?.controls['combinePropertyValue']"
                                                [combineLabel]="translateHelper.localize(block.combineProperty?.name)" [combineSelectList]="block.combineProperty?.availableValues" appearance="filter" floatLabel="always"
                                                [placeholder]="('please_select'|translate) + ' ' + translateHelper.localize(block.property?.name)"></app-select-button>

                                        </ng-container>
                                        <ng-container *ngIf="block?.property?.type =='checkbox'">
                                            <app-checkbox-input [control]="propertyControl?.at(i)?.controls['value']" [label]="translateHelper.localize(block?.property?.name)">
                                            </app-checkbox-input>
                                        </ng-container>
                                        <ng-container *ngIf="block?.property?.type =='exact'">
                                            <app-text-input [control]="propertyControl?.at(i)?.controls['value']" appearance="legacy" [label]="translateHelper.localize(block?.property?.name)"></app-text-input>
                                        </ng-container>
                                        <ng-container *ngIf="block?.type =='price'">
                                            <form [formGroup]="priceForm">
                                                <app-range-input [minControl]="priceForm.get('min')" [maxControl]="priceForm.get('max')" appearance="filter" [label]="{en : 'Price' , ar: 'سعر' }">
                                                </app-range-input>
                                            </form>
                                        </ng-container>
                                        <ng-container *ngIf="block?.property?.type =='range' ">
                                            <app-range-input [minControl]="propertyControl?.at(i)?.controls['min']" [maxControl]="propertyControl?.at(i)?.controls['max']" appearance="filter" [label]="block?.property?.name" [customLabel]="block?.property?.filterLabel"></app-range-input>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <div class="filter-actions">
                        <button (click)="reset()" class="btn btn-sm bg-gray-light">
                            <div class="label font-bold">{{"reset"|translate}}</div>
                        </button>

                        <button (click)="submit()" class="btn btn-sm apply-btn">
                            <div class="label">{{"apply"|translate}} ></div>
                        </button>
                    </div>
                    <!--  <div class="text-right mt-3">
                        <button type="button" (click)="submit();" class="btn search-btn">{{"search"|translate}}</button>
                    </div> -->
                </form>
            </div>
        </div>
    </div>
</div>

<!-- <div class="view-options" [ngClass]="{
    'view-options--offcanvas--always': offcanvas === 'always',
    'view-options--offcanvas--mobile': offcanvas === 'mobile'
}">
    <div class="view-options__filters-button">
        <button type="button" class="filters-button" (click)="sidebar.open()">
            <app-icon class="filters-button__icon" name="filters-16" size="16"></app-icon>
            <span class="filters-button__title">{{"search"|translate}}</span>
        </button>
    </div>
</div> -->